import React from 'react';
import { Box, useMediaQuery, useTheme } from '@material-ui/core';
import { ChevronUp } from '@carbon/icons-react';
import { colorSet } from '@components/Provider';
import { Spotlight, useSpotlight } from '@components/Spotlight';
import ViewerRightDrawer from '@components/Chat/ChatMenu/Viewer/ViewerRightDrawer';
import AnnotationListEntry from '@components/Chat/ChatMenu/Viewer/components/AnnotationListEntry';
import { TutorialStepProps } from '../CapaViewTutorial';

const TutorialStep4_2 = ({
  handleNextStep,
  mockComments
}: TutorialStepProps) => {
  const { load, width, height } = useSpotlight();
  const matches600 = useMediaQuery(useTheme().breakpoints.down('xs'));

  return (
    <>
      {load && (
        <Spotlight
          cutOutTarget={{ x: '50%', y: 0 }}
          radiusSize={matches600 ? 300 : height / 2}
          CTATitle={
            <Box display={'flex'} alignItems={'center'}>
              주석목록 확인
              <ChevronUp color={colorSet.primary500} size={26} />
            </Box>
          }
          CTADirection={'bottom'}
          CTADescription={
            '주석 목록에서 프로젝트에 남겨진 모든 주석을 확인하고 관리할 수 있어요.'
          }
          handleNextStep={() => handleNextStep('5')}
          addX={0}
          addY={matches600 ? 220 : height / 2}
          clientHeight={height}
          clientWidth={width}
          zIndex={10000}
        />
      )}
      <ViewerRightDrawer
        open={true}
        onClose={() => ({})}
        matches={true}
        listTabValue={'annotation'}
        onDownloadAll={() => ({})}
      >
        <Box overflow={'auto'}>
          {mockComments.map((annotation) => {
            return (
              <AnnotationListEntry
                key={annotation.annotationId}
                onClickAnnotation={() => ({})}
                annotation={annotation}
              />
            );
          })}
        </Box>
      </ViewerRightDrawer>
    </>
  );
};

export default TutorialStep4_2;
